import { useQuery } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC } from 'react';
import { useParams } from 'react-router-dom';

import LoadingIndicator from 'primitives/LoadingIndicator';

import ErrorMessage from 'components/ErrorMessage';

import NotificationCategoryMatrix from './NotificationCategoryMatrix';

const USER_QUERY = gql(`
  query getUserNotificationPreferences($userId: ID!) {
    user(id: $userId) {
      id
      notificationPreferences {
        id
        whatsappEnabled
        emailEnabled
        smsEnabled
        platformEnabled
      }
      notificationCategoryPreferences {
        category
        subcategories {
          id
          category
          subcategory
          emailEnabled
          smsEnabled
          pushEnabled
          whatsappEnabled
        }
      }
    }
  }
`);

const UserNotificationPreferences: FC = () => {
  const { userId } = useParams<{ userId: string }>() as { userId: string };

  const { loading, error, data, refetch } = useQuery(USER_QUERY, {
    variables: { userId },
  });

  if (loading) return <LoadingIndicator />;

  if (error || !data) return <ErrorMessage error={error} refetch={refetch} />;

  const user = data.user;

  return (
    <NotificationCategoryMatrix
      userId={user.id}
      categories={user.notificationCategoryPreferences ?? []}
    />
  );
};

export default UserNotificationPreferences;
